import React, { useState } from "react";
import { Box, Link } from "@mui/material";
import { colors, fonts, layout } from "../../theme/tokens";
import servicesData from "../../data/servicesData";

const Services = () => {
  const [active, setActive] = useState(0);
  const current = servicesData[active];

  return (
    <Box
      component="section"
      sx={{
        pt: { xs: "56px", md: "70px" },
        pb: "64px",
        px: { xs: "20px", md: "28px" },
      }}
    >
      <Box sx={{ maxWidth: layout.maxWidth, mx: "auto" }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            flexWrap: "wrap",
            gap: "20px",
            mb: "38px",
          }}
        >
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <Box
                sx={{ width: "26px", height: "2px", background: colors.amber }}
              />
              <Box
                sx={{
                  fontFamily: fonts.display,
                  fontSize: "12.5px",
                  fontWeight: 600,
                  letterSpacing: ".2em",
                  color: colors.steelBlue,
                }}
              >
                WHAT WE DO
              </Box>
            </Box>
            <Box
              component="h2"
              sx={{
                fontFamily: fonts.display,
                fontWeight: 700,
                fontSize: "clamp(30px,3.6vw,44px)",
                lineHeight: 1.08,
                letterSpacing: "-.02em",
                color: colors.navyInk,
                mt: "16px",
                mb: 0,
                maxWidth: "560px",
              }}
            >
              Tailored solutions across our core pillars
            </Box>
          </Box>
          <Link
            href="/services"
            underline="none"
            sx={{
              background: "#fff",
              border: `1px solid ${colors.line}`,
              color: colors.brandNavy,
              fontFamily: fonts.body,
              fontWeight: 700,
              fontSize: "14px",
              p: "13px 24px",
              borderRadius: "40px",
            }}
          >
            View all services
          </Link>
        </Box>

        {/* Explorer */}
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: ".86fr 1.14fr" },
            gap: "18px",
            alignItems: "stretch",
          }}
        >
          {/* Tabs */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            {servicesData.map((s, i) => {
              const on = i === active;
              return (
                <Box
                  key={s.id}
                  component="button"
                  onClick={() => setActive(i)}
                  onMouseEnter={() => setActive(i)}
                  sx={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    width: "100%",
                    textAlign: "left",
                    border: `1px solid ${on ? "transparent" : colors.lineSoft}`,
                    background: on ? "#fff" : "rgba(255,255,255,.5)",
                    borderRadius: "16px",
                    p: "17px 20px",
                    boxShadow: on
                      ? "0 14px 34px -22px rgba(14,27,42,.55)"
                      : "none",
                    transition: "all .25s",
                    transform: on ? "translateX(4px)" : "none",
                  }}
                >
                  <Box
                    sx={{
                      fontFamily: fonts.display,
                      fontWeight: 700,
                      fontSize: "13px",
                      color: on ? colors.amber : "#B3BCC7",
                    }}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      fontFamily: fonts.body,
                      fontWeight: 600,
                      fontSize: "15.5px",
                      color: colors.brandNavy,
                    }}
                  >
                    {s.title}
                  </Box>
                  <Box
                    sx={{
                      opacity: on ? 1 : 0.4,
                      color: on ? colors.amber : colors.subtleText,
                      transform: on ? "translateX(2px)" : "none",
                      transition: "transform .25s,opacity .25s",
                    }}
                  >
                    →
                  </Box>
                </Box>
              );
            })}
          </Box>

          {/* Detail panel */}
          <Box
            sx={{
              background: "linear-gradient(160deg,#1E3A57,#0E1B2A)",
              borderRadius: "26px",
              p: { xs: "30px 26px", md: "42px 44px" },
              position: "relative",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: "-60px",
                right: "-40px",
                fontFamily: fonts.display,
                fontWeight: 700,
                fontSize: "220px",
                lineHeight: 1,
                color: "rgba(255,255,255,.04)",
                pointerEvents: "none",
              }}
            >
              {String(active + 1).padStart(2, "0")}
            </Box>
            <Box sx={{ position: "relative" }}>
              <Box
                sx={{
                  fontFamily: fonts.display,
                  fontSize: "13px",
                  fontWeight: 600,
                  letterSpacing: ".04em",
                  color: colors.amberDot,
                }}
              >
                {current.tagline}
              </Box>
              <Box
                component="h3"
                sx={{
                  fontFamily: fonts.display,
                  fontWeight: 700,
                  fontSize: { xs: "24px", md: "30px" },
                  lineHeight: 1.12,
                  color: "#fff",
                  mt: "12px",
                  mb: 0,
                }}
              >
                {current.title}
              </Box>
              <Box
                sx={{
                  fontFamily: fonts.body,
                  fontSize: "15.5px",
                  lineHeight: 1.65,
                  color: "#A9BACD",
                  mt: "16px",
                  maxWidth: "520px",
                }}
              >
                {current.description}
              </Box>
              <Box
                sx={{
                  mt: "26px",
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                  gap: "10px 22px",
                }}
              >
                {current.offerings.map((o) => (
                  <Box
                    key={o}
                    sx={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                      fontFamily: fonts.body,
                      fontSize: "14px",
                      color: "#D4DEE8",
                      lineHeight: 1.4,
                    }}
                  >
                    <Box
                      component="span"
                      sx={{ color: colors.amberDot, mt: "1px", flex: "none" }}
                    >
                      ✓
                    </Box>
                    {o}
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Services;
